import { useMutation, useQueryClient } from "@tanstack/react-query"
import { makeRetryDocument } from "../../domain/use-cases/retry-document"
import { httpDocumentRepository } from "../../data/repositories/document-repository"

const retryDocument = makeRetryDocument(httpDocumentRepository)

export const useRetryDocument = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (docId: string) => retryDocument(docId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["documents"] }),
  })
}
